import { Component, Input } from '@angular/core';
import { Tag } from '../../../app/app.interfaces';

@Component({
  selector: 'tag-list',
  templateUrl: 'tag-list.html'
})

export class TagList {
  @Input() tags: Tag[];
}



// WEBPACK FOOTER //
// ./src/partials/tags/tag-list/tag-list.ts